module.exports = __webpack_public_path__ + "static/img/ic_pk@2x.423c0660.png";